import api from "@/api";

const getOrganizationsTerminals = function(org_id, params = {}) {
  return api.get(`/organizations/${org_id}/terminals`, { params });
};
const getTerminalServices = function(term_id) {
  return api.get(`/terminals/${term_id}/services`);
};
const getTerminalServiceById = function(term_id, service_id) {
  return api.get(`/terminals/${term_id}/services/${service_id}`);
};
const getTerminalGeneralInfo = function(term_id) {
  return api.get(`/terminals/${term_id}`);
};
const getTerminalMaintenance = function(term_id) {
  return api.get(`/terminals/${term_id}/maintenances`);
};
const getTerminalServicesPriceSchedules = function(term_id, service_id ) {
  return api.get(`/terminals/${term_id}/services/${service_id}/schedules`);
};
const getTerminalServicesPriceSchedule = function(term_id, service_id,schedule_id ) {
  return api.get(`/terminals/${term_id}/services/${service_id}/schedules/${schedule_id}`);
};

const getTerminalOptions = function(term_id) {
  return api.get(`/terminals/${term_id}/options`);
};
const updateTerminalOptions = function (term_id, data) {
  return api.patch(`/terminals/${term_id}/options`, data);
};
const getTerminalMessages = function(term_id) {
  return api.get(`/terminals/${term_id}/messages`);
};



const postOrganizationsTerminals = function(organizationsId, params = {}) {
  /*{
    "serial_number": "string",
    "activation_date": "2020-02-11T05:53:42.167Z",
    "activation_code": "string",
    "address": "string"
  }*/
  return api.post(`/organizations/${organizationsId}/terminals`, params);
};
const postTerminalMaintenance = function(term_id, params = {}) {
  // {
  //   "date": "2020-02-13",
  //   "note": "string",
  //   "technician_name": "string",
  //   "next_date": "2020-02-13"
  // }
  return api.post(`/terminals/${term_id}/maintenances`, params);
};
const postTerminalService = function(term_id, params = {}) {
  // {
  //   "code": "string",
  //   "icon": "car-wash-1",
  //   "name": "string",
  //   "full_name": "string",
  //   "price": 0,
  //   "description": "string"
  // }
  return api.post(`/terminals/${term_id}/services`, params);
};
const postTerminalServicesPriceSchedule = function(term_id, service_id, params={}) {
  // {
  //   "start_time": "string",
  //   "end_time": "string",
  //   "price": 0
  // }
  return api.post(`/terminals/${term_id}/services/${service_id}/schedules`, params);
};

const changeActiveMember = function (org_id, term_id) {
  return api.post(`/organizations/${org_id}/terminals/${term_id}/active_member`);
}

const removeActiveMember = function (org_id, term_id) {
  return api.delete(`/organizations/${org_id}/terminals/${term_id}/active_member`);
}

const patchTerminalMaintenance = function(  term_id, maintenance_id, params = {}) {
  // {
  //   "date": "2020-02-13",
  //   "note": "string",
  //   "technician_name": "string",
  //   "next_date": "2020-02-13"
  // }

  return api.patch(
    `/terminals/${term_id}/maintenances/${maintenance_id}`,
    params
  );
};
const patchTerminalService = function(term_id, service_id, params = {}) {
  // {
  //   "icon": "car-wash-1",
  //   "name": "string",
  //   "full_name": "string",
  //   "description": "string",
  //   "price": 0
  // }

  return api.patch(`/terminals/${term_id}/services/${service_id}`, params);
};
const patchTerminalLock = function(term_id) {
  return api.post(`/terminals/${term_id}/lock`);
};
const patchTerminalServicesPriceSchedule = function(term_id, service_id, schedule_id, params = {}) {
  // {
  //   "start_time": "string",
  //   "end_time": "string",
  //   "price": 0
  // }
  return api.patch(
    `/terminals/${term_id}/services/${service_id}/schedules/${schedule_id}`,
    params
  );
};
const deleteTerminalLock = function(term_id) {
  return api.delete(`/terminals/${term_id}/lock`);
};

const rebootTerminal = function(term_id) {
  return api.post(`/terminals/${term_id}/reboot`);
};

const sendEmailTerminal = function(term_id, data) {
  return api.post(`/terminals/${term_id}/send`, data);
};

const stopWashing = function(term_id, data) {
  return api.post(`/terminals/${term_id}/stop-wash`, data);
};

const cancelWashing = function(term_id, data) {
  return api.post(`/terminals/${term_id}/cancel-wash`, data);
};

const openGate = function(term_id, data) {
  return api.post(`/terminals/${term_id}/open-gate`, data);
};

const closeGate = function(term_id, data) {
  return api.post(`/terminals/${term_id}/close-gate`, data);
};

const runWash = function(term_id, data) {
  return api.post(`/terminals/${term_id}/run-wash`, data);
};

const pauseWashing = function(term_id, data) {
  return api.post(`/terminals/${term_id}/pause-wash`, data);
};
const playWashing = function(term_id, data) {
  return api.post(`/terminals/${term_id}/play-wash`, data);
};

const deleteTerminal = function(term_id) {
  return api.delete(`/terminals/${term_id}`);
};
const deleteTerminalMaintenance = function(term_id, maintenance_id) {
  return api.delete(`/terminals/${term_id}/maintenances/${maintenance_id}`);
};
const deleteTerminalService = function(term_id, service_id) {
  return api.delete(`/terminals/${term_id}/services/${service_id}`);
};
const deleteTerminalServicesPriceSchedule = function(term_id, service_id, schedule_id ) {
  return api.delete(`/terminals/${term_id}/services/${service_id}/schedules/${schedule_id}`);
};

const getStats = function(id, params = {}) {
  return api.get(`/terminals/${id}/stats`, {
    params: params
  });
};
const getLogentry = function(id, params = {}) {
  return api.get(`/terminals/${id}/logentries`, {
    params: params
  });
};

const getLogentryXmlReport = function(id, params = {}) {
  return api.post(`/terminals/${id}/logentries/xls`, {}, params);
};

const getLogentryXmlClientReport = function(id, params = {}) {
  return api.post(`/terminals/${id}/logentries/client-xls`, {}, params);
};

const sendCommand = function(id, command) {
  return api.post(`/terminals/${id}/${command}`);
};

export default {
  getOrganizationsTerminals,
  getTerminalGeneralInfo,
  getTerminalServices,
  getTerminalServiceById,
  getTerminalMaintenance,
  getTerminalServicesPriceSchedules,
  getTerminalServicesPriceSchedule,
  getTerminalMessages,

  getTerminalOptions,
  updateTerminalOptions,

  postOrganizationsTerminals,
  postTerminalMaintenance,
  postTerminalService,
  postTerminalServicesPriceSchedule,

  changeActiveMember,
  removeActiveMember,

  patchTerminalMaintenance,
  patchTerminalService,
  patchTerminalLock,
  patchTerminalServicesPriceSchedule,

  rebootTerminal,
  sendEmailTerminal,
  stopWashing,
  cancelWashing,
  openGate,
  closeGate,
  runWash,
  pauseWashing,
  playWashing,

  deleteTerminalLock,
  deleteTerminal,
  deleteTerminalMaintenance,
  deleteTerminalService,
  deleteTerminalServicesPriceSchedule,

  getStats,
  getLogentry,
  getLogentryXmlReport,
  getLogentryXmlClientReport,

  sendCommand
};
